import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { BrugerHttpClient, ParametreForAktuelleInstallation } from "@e-forsyning/common/http";

import type { EjendomKoordinatPunkt } from "../enheds-placering/afstand";

interface EjendomKoordinaterResponse {
    koordinater?: Array<{ enr: number; brd?: number; lng?: number }>;
}

@Injectable({ providedIn: "root" })
export class KortEjendommeRepository {
    constructor(private readonly brugerHttp: BrugerHttpClient) {}

    public hentAlleKoordinater(): Observable<EjendomKoordinatPunkt[]> {
        return this.brugerHttp.get<EjendomKoordinaterResponse>("api/GetEjendomKoordinater", ParametreForAktuelleInstallation.false).pipe(
            map((response) => {
                const punkter: EjendomKoordinatPunkt[] = [];
                for (const ejendom of response?.koordinater ?? []) {
                    if (ejendom.enr <= 0 || ejendom.brd == null || ejendom.lng == null || (ejendom.brd === 0 && ejendom.lng === 0)) {
                        continue;
                    }
                    punkter.push({ ejendomNr: ejendom.enr, latitude: ejendom.brd, longitude: ejendom.lng });
                }
                return punkter;
            })
        );
    }
}
